import { render, staticRenderFns } from "./FormularioPontoSig.vue?vue&type=template&id=19d4f840&scoped=true&"
import script from "./FormularioPontoSig.vue?vue&type=script&lang=js&"
export * from "./FormularioPontoSig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d4f840",
  null
  
)

export default component.exports